// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1TvtC","buttons":"SendReceipts_buttons__1umY6","email":"SendReceipts_email__im4DJ","bookApptTitle":"SendReceipts_bookApptTitle__38rIN"};